/**
 * Guards VoucherActionModal's services/massageTypes load against a slow
 * response for a previously-open voucher landing after a newer voucher has
 * already opened. Each load bumps a monotonic id; a response is only
 * applied if its id is still the current one. Framework-agnostic (no React,
 * no fetch) so the bookkeeping can be unit tested directly - the actual
 * network cancellation is a separate AbortController at the call site.
 */
export class LoadRequestGuard {
    private currentId = 0;

    /** Starts a new load and returns its id. Any earlier in-flight load becomes stale immediately. */
    start(): number {
        this.currentId += 1;
        return this.currentId;
    }

    /** True when requestId is still the most recently started load. */
    isCurrent(requestId: number): boolean {
        return requestId === this.currentId;
    }
}
